import React from "react"

import Wrapper from "../components/Wrapper"
import Form from "../components/Form"
import DatePicker from "../components/Datepicker"
import TimeButtons from "../components/TimeButtons"

function encode(data) {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&")
}

function validateZipcode(zipcode) {
    var regex = /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i
    return regex.test(zipcode)
}

function validateNumber(number) {
    var regex = /^[0-9]+$/
    return regex.test(number)
}

function validatePhone(phone) {
    var regex = /^\(?([+]31|0031|0)-?6(\s?|-)([0-9]\s{0,3}){8}$/
    return regex.test(phone)
}

function validateEmail(email) {
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(email)
}

function parseDate(date) {
    var parts = date.split("-");
    return new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
}

export default function Home() {
    const [state, setState] = React.useState({})
    const [errors, setError] = React.useState({})
    const [errormsg, setErrormsg] = React.useState({})

    const handleChange = e => {
        switch (e.target.name) {
            case "Postcode":
                setError({
                    ...errors,
                    [e.target.name]: validateZipcode(e.target.value),
                })
                break
            case "Huisnummer":
                setError({
                    ...errors,
                    [e.target.name]: validateNumber(e.target.value),
                })
                break
            case "Telefoonnummer":
                setError({
                    ...errors,
                    [e.target.name]: validatePhone(e.target.value),
                })
                break
            case "Email":
                setError({
                    ...errors,
                    [e.target.name]: validateEmail(e.target.value),
                })
                break
            default:
                break
        }

        setState({ ...state, [e.target.name]: e.target.value })
        console.log(state)
    }

    const formatter = new Intl.DateTimeFormat("nl-NL", {
        dateStyle: "short"
    })

    const handleDateChange = (name, e) => {
        setState({ ...state, [name]: formatter.format(e[0]) })
    }

    const handleTimeChange = (e) => {
        setState({ ...state, "Tijd": e.target.innerText })
    }

    const handleSubmit = e => {
        e.preventDefault()
        const form = e.target
        let errorstate = {}


        if ((!state.Voornaam || state.Voornaam === undefined) && !state.Achternaam) {
            errorstate.Voornaam = "Vul je voornaam in."
        }

        if ((!state.Achternaam || state.Achternaam === undefined) && !state.Voornaam) {
            errorstate.Achternaam = "Vul je achternaam in."
        }

        const adres = [state.Huisnummer, state.Postcode, state.Adres, state.Woonplaats]

        if (adres.map((v) => v === "" || v === undefined).includes(false)) {
            if (errors.Postcode === undefined) {
                errorstate.Postcode = "Vul je postcode in."
            }

            if (!errors.Postcode) {
                errorstate.Postcode = "Vul een geldige postcode in."
            }

            if (!errors.Huisnummer || errors.Huisnummer === undefined) {
                errorstate.Huisnummer = "Vul je huisnummer in."
            }

            if (!state.Adres || state.Adres === undefined) {
                errorstate.Adres = "Vul je adres in."
            }

            if (!state.Woonplaats || state.Woonplaats === undefined) {
                errorstate.Woonplaats = "Vul je woonplaats in."
            }
        }

        if (!errors.Telefoonnummer === undefined) {
            errorstate.Telefoonnummer = "Vul je telefoonnummer in."
        }

        if (!errors.Telefoonnummer) {
            errorstate.Telefoonnummer = "Vul een geldig telefoonnummer in."
        }

        if (errors.Email === undefined) {
            errorstate.Email = "Vul je email adres in."
        }

        if (!errors.Email) {
            errorstate.Email = "Vul een geldig email adres in."
        }

        if (!state["datum"]) {
            errorstate.Date = "Vul een datum in."
        }

        if (!state["Tijd"]) {
            errorstate.Time = "Vul een tijd in."
        }

        setErrormsg(errorstate)

        if (!Object.keys(errorstate).length) {
            fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: encode({
                    "form-name": form.getAttribute("name"),
                    ...state,
                }),
            })
                .then(() => (window.location = "/succes"))
                .catch(error => alert(error))
        }
    }

    return (
        <Wrapper>
            <form
                name="afspraak"
                method="post"
                action="/"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                onSubmit={handleSubmit}
            >
                <p hidden>
                    <label>
                        Vul dit veld niet in (bescherming tegen robots):
            <input name="bot-field" onChange={handleChange} />
                    </label>
                </p>
                <p style={{ marginBlockStart: "0" }}>We kijken er naar uit om je tijdens een persoonlijke afspraak te voorzien van professioneel interieur advies.
Voor het maken van de afspraak hebben we een aantal gegevens van je nodig.</p>
                <div className="personal">
                    <h2>Contactgegevens</h2>
                    <p style={{ marginBlockStart: "0" }}>Graag ontvangen we je voor en/of achternaam, t.b.v. de juiste informatie in onze agenda:</p>
                </div>
                <Form
                    onChange={handleChange}
                    hasData={state.Voornaam && true}
                    valid={state.Voornaam && true}
                    error={errormsg.Voornaam}
                    name="Voornaam"
                    autocomplete="given-name"
                >
                    Voornaam:
        </Form>
                <Form
                    onChange={handleChange}
                    hasData={state.Achternaam && true}
                    valid={state.Achternaam && true}
                    error={errormsg.Achternaam}
                    name="Achternaam"
                    autocomplete="family-name"
                >
                    Achternaam:
        </Form>
                <div
                    style={{
                        fontSize: "0px",
                        maxWidth: "610px",
                    }}
                >
                    <div className="personal">
                        <h2>Adres</h2>
                        <p style={{ marginBlockStart: "0" }}>Wanneer je graag advies van de personal stylist aan huis wenst, vul dan hier je woonadres in:</p>
                    </div>
                    <Form
                        onChange={handleChange}
                        hasData={state.Postcode && true}
                        valid={errors.Postcode}
                        error={errormsg.Postcode}
                        name="Postcode"
                        autocomplete="postal-code"
                        inline
                    >
                        Postcode
          </Form>
                    <Form
                        onChange={handleChange}
                        hasData={state.Huisnummer && true}
                        valid={errors.Huisnummer}
                        error={errormsg.Huisnummer}
                        name="Huisnummer"
                        autocomplete="on"
                        inline
                        small
                    >
                        Huisnummer
          </Form>
                    <Form
                        onChange={handleChange}
                        hasData={state.Toevoeging && true}
                        valid={state.Toevoeging && true}
                        name="Toevoeging"
                        autocomplete="on"
                        inline
                        small
                    >
                        Toevoeging
          </Form>
                    <Form
                        onChange={handleChange}
                        hasData={state.Adres && true}
                        valid={state.Adres && true}
                        error={errormsg.Adres}
                        name="Adres"
                        autocomplete="street-address"
                        inline
                    >
                        Adres
          </Form>
                    <Form
                        onChange={handleChange}
                        hasData={state.Woonplaats && true}
                        valid={state.Woonplaats && true}
                        error={errormsg.Woonplaats}
                        name="Woonplaats"
                        autocomplete="address-level2"
                        inline
                    >
                        Woonplaats
          </Form>
                </div>
                <div
                    className="personal"
                    style={{
                        marginTop: "10px",
                    }}
                >
                    <h2>Hoe kunnen we je bereiken?</h2>
                    <p style={{ marginBlockStart: "0" }}>We ontvangen graag het telefoonnummer en e-mailadres i.v.m eventuele bijzonderheden:</p>
                </div>
                <Form
                    onChange={handleChange}
                    hasData={state.Telefoonnummer && true}
                    valid={errors.Telefoonnummer}
                    error={errormsg.Telefoonnummer}
                    name="Telefoonnummer"
                    autocomplete="tel"
                >
                    Telefoonnummer
        </Form>
                <Form
                    onChange={handleChange}
                    hasData={state.Email && true}
                    valid={errors.Email}
                    error={errormsg.Email}
                    name="Email"
                    autocomplete="email"
                >
                    E-mail
        </Form>
                <div className="personal">
                    <h2>Kies je datum en tijd</h2>
                    <div className="form-field">
                        <DatePicker
                            onChange={data => handleDateChange("datum", data)}
                            name="datum"
                            inline
                            wider
                        >
                            Datum
            </DatePicker>

                        {errormsg.Date && !state["datum"] && <p className="form-karwei__error-text">{errormsg.Date}</p>}
                    </div>
                </div>

                {state["datum"] &&
                    <div className="form-field">
                        <div className="form-field--inline--wider">
                            <label htmlFor="Tijd" style={{ margin: "0 0 10px" }} className="form-field__label">Tijd</label>
                            <TimeButtons className="form-field__text" times={{
                                0: ["9:00", "11:00", "14:00", "16:00", "19:00"],
                                1: ["9:00", "11:00", "14:00", "16:00", "19:00"],
                                2: ["9:00", "11:00", "14:00", "16:00", "19:00"],
                                3: ["9:00", "11:00", "14:00", "16:00", "19:00"],
                                4: ["9:00", "11:00", "14:00", "16:00", "19:00"],
                                5: ["9:00", "11:00", "14:00", "16:00", "19:00"],
                                6: ["9:00", "11:00", "14:00", "16:00"]
                            }} onChange={handleTimeChange} day={parseDate(state["datum"]).getDay()} />
                            {state["datum"] && !state["Tijd"] && errormsg.Time && <p className="form-karwei__error-text">{errormsg.Time}</p>}
                        </div>
                    </div>
                }

                <Form
                    onChange={handleChange}
                    name="Opmerkingen"
                    large={true}
                >
                    Opmerkingen
                </Form>

                <input type="hidden" name="form-name" value="afspraak" />
                <input type="hidden" name="Tijd" />

                <p>
                    I.v.m. de corona-maatregelen willen wij je vragen dat wanneer je klachten hebt behorende bij corona, zoals beschreven op de website van de RIVM, je de afspraak verplaatst naar een later moment. Je kunt dit doen door telefonisch contact op te nemen met onze bouwmarkt via +31 344 635653.
                    Uiteraard geldt dit ook voor onze styliste, bij klachten aan haar kant zal zij de afspraak verplaatsen en neemt de bouwmarkt telefonisch contact met je op.
                            </p>

                <div className="footer">
                    <div className="footer__item">
                        <p style={{
                            color: "grey",
                            fontSize: "11px"
                        }}>Je gegevens worden na afloop van het gesprek gewist, tenzij er een vervolgafspraak plaatsvindt.</p>
                    </div>
                    <span className="spacer"></span>
                    <div className="footer__item--buttons">
                        <button type="submit" className="button--success">
                            opdracht bevestigen
                        </button>
                    </div>
                </div>
            </form>
        </Wrapper>
    )
}
